/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetUserCCsResponseItems,
    GetUserCCsResponseItemsFromJSON,
    GetUserCCsResponseItemsFromJSONTyped,
    GetUserCCsResponseItemsToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetUserCCsResponse
 */
export interface GetUserCCsResponse {
    /**
     * 
     * @type {Array<GetUserCCsResponseItems>}
     * @memberof GetUserCCsResponse
     */
    items?: Array<GetUserCCsResponseItems>;
}

export function GetUserCCsResponseFromJSON(json: any): GetUserCCsResponse {
    return GetUserCCsResponseFromJSONTyped(json, false);
}

export function GetUserCCsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserCCsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : ((json['items'] as Array<any>).map(GetUserCCsResponseItemsFromJSON)),
    };
}

export function GetUserCCsResponseToJSON(value?: GetUserCCsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : ((value.items as Array<any>).map(GetUserCCsResponseItemsToJSON)),
    };
}


